module.exports = __webpack_public_path__ + "static/media/img.e0067fe3.png";